<template>
  <b-card
    no-body
    :class="{
      'card-no-revisada':
        partido.voc_revisada == 'n' || partido.voc_revisada == null,
      'card-revisada': partido.voc_revisada == 's',
    }"
    @click="changePartido"
  >
    <b-row class="borde-titulo">
      <b-col md="5">{{ partido.categoria }}</b-col>
      <b-col md="5" >{{ partido.fecha_aux }}</b-col>
      <b-col md="2"><span style="font-size:8px;padding:0px;color:gray;background:#ffffff">{{ partido.id_campeonato }}-{{ partido.id_partido }}</span></b-col>
    </b-row>
    <b-row>
      <b-col md="1" style=";display: flex;align-items: center;">
        <img :src="partido.foto_local" alt="" style="width:22px; height:22px" />
      </b-col>
      <b-col md="5" style="padding-left: 16px; padding-right: 0">
        <small class="mr-1 text-capitalize">{{ partido.local }}</small>
      </b-col>
      <b-col md="5" style="display:flex; align-items:center">
        <img
          :src="require('@/assets/images/recursos/amarilla.png')"
          alt=""
          style="width:12px; height:12px"
        />
        <small class="mr-1" style="color:gray; margin-left:1px">{{
          partido.amarillasLocal
        }}</small>

        <img
          :src="require('@/assets/images/recursos/roja.png')"
          alt=""
          style="width:12px; height:12px"
        />
        <small class="mr-1" style="color:gray; margin-left:1px">{{
          partido.rojasLocal
        }}</small>

        <img
          :src="require('@/assets/images/recursos/dosamar.png')"
          alt=""
          style="width:12px; height:12px"
        />
        <small class="mr-1" style="color:gray; margin-left:1px">{{
          partido.DALocal
        }}</small>
      </b-col>
    </b-row>
    <b-row style="margin-top:3px">
      <b-col md="1" style=";display: flex;align-items: center;">
        <img
          :src="partido.foto_visita"
          alt=""
          style="width:22px; height:22px"
        />
      </b-col>
      <b-col md="5" style="padding-left: 16px; padding-right: 0">
        <small class="mr-1 text-capitalize">{{ partido.visita }}</small>
      </b-col>
      <b-col md="5" style="display:flex; align-items:center">
        <img
          :src="require('@/assets/images/recursos/amarilla.png')"
          alt=""
          style="width:12px; height:12px"
        />
        <small class="mr-1" style="color:gray; margin-left:1px">{{
          partido.amarillasVisita
        }}</small>
        <img
          :src="require('@/assets/images/recursos/roja.png')"
          alt=""
          style="width:12px; height:12px"
        />
        <small class="mr-1" style="color:gray; margin-left:1px">{{
          partido.rojasVisita
        }}</small>

        <img
          :src="require('@/assets/images/recursos/dosamar.png')"
          alt=""
          style="width:12px; height:12px"
        />
        <small class="mr-1" style="color:gray; margin-left:1px">{{
          partido.DAVisita
        }}</small>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  //   xxx
  // xxx
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
  },
  props: {
    partido: Object(),
  },
  setup(props, { emit }) {
    function changePartido() {
      emit('changePartido', props.partido)
    }
    return {
      changePartido,
    }
  },
}
</script>
<style>
.card-no-revisada {
  padding: 5px;
  margin-bottom: 1rem;
  cursor: pointer;
  background-color: #edeff1;
}
.card-revisada {
  padding: 5px;
  margin-bottom: 1rem;
  cursor: pointer;
  background-color: #92f392;
}
.borde-titulo {
  border-bottom: 1px solid;
  margin-bottom: 7px;
  color: rosybrown;
  font-size: 12px;
  font-weight: 500;
}
</style>
